// Rótulo do grau de risco (classificação HRN) em tela.
//
// O texto em português continua sendo o valor canônico: é ele que vem do banco
// em `classificacaoRisco` e é ele que decide a cor do selo. Aqui só existe o
// caminho texto → chave de dicionário, para que a tabela mostre "Very high"
// sem que o dado gravado mude de idioma.

/** Assinatura mínima do `t` do `useI18n()` — a constante não importa React. */
type Traduzir = (chave: string) => string;

const RAIZ = 'apreciacaoTabelas.classificacao';

function normalizar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

/** Português normalizado → último segmento da chave em `apreciacaoTabelas.classificacao`. */
export const CHAVE_CLASSIFICACAO: Record<string, string> = {
  'inaceitavel': 'inaceitavel',
  'extremo': 'extremo',
  'muito alto': 'muitoAlto',
  'alto': 'alto',
  'significante': 'significante',
  'baixo': 'baixo',
  'muito baixo': 'muitoBaixo',
  'aceitavel': 'aceitavel',
  'critico': 'critico',
  'medio': 'medio',
  'baixo, porem significativo': 'baixoSignificativo',
};

/**
 * Devolve a classificação traduzida. Classificação que veio do banco e não está
 * na escala conhecida sai como está — texto do usuário não vira chave crua.
 */
export function traduzirClassificacao(t: Traduzir, classificacao?: string): string {
  if (!classificacao) return '';
  const chave = CHAVE_CLASSIFICACAO[normalizar(classificacao)];
  return chave ? t(`${RAIZ}.${chave}`) : classificacao;
}
